import { render, staticRenderFns } from "./tournamentPage-skeleton.vue?vue&type=template&id=1b6c989f&"
import script from "./tournamentPage-skeleton.vue?vue&type=script&lang=js&"
export * from "./tournamentPage-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports